<template>
  <b-overlay :show="overlay" rounded="sm">
    <b-row v-if="product">
      <b-col cols="12">
        <h4 class="text-primary">
          <feather-icon icon="PlusSquareIcon" size="20" />
          Edit a product
        </h4>

        <b-row>
          <b-media class="my-2 col-12">
            <validation-observer ref="refFormObserver">
              <b-card class="">
                <b-row>
                  <h4 class="text-primary col-12">Information</h4>

                  <!-- Product picture -->
                  <b-col cols="12" md="6">
                    <p class="mb-1">Product picture</p>
                    <b-avatar
                        ref="previewEl"
                        :src="base64ImageSrc"
                        class="cursor-pointer mb-1"
                        rounded
                        size="150px"
                        @click.native="$refs.refInputEl.click()"
                    >
                      <feather-icon
                          v-if="base64ImageSrc === null"
                          icon="PlusSquareIcon"
                          size="100"
                      />
                    </b-avatar>
                    <input
                        ref="refInputEl"
                        accept=".jpg,.jpeg,.png,.svg"
                        class="d-none"
                        type="file"
                        @change="setCover($event)"
                    />
                  </b-col>

                  <!-- Sidebar picture -->
                  <b-col cols="12" md="6">
                    <p class="mb-1">Product Sidebar Picture</p>
                    <b-avatar
                        ref="previewElSidebar"
                        :src="base64ImageSrcSidebar"
                        class="cursor-pointer mb-1"
                        rounded
                        size="150px"
                        @click.native="$refs.refInputElSidebar.click()"
                    >
                      <feather-icon
                          v-if="base64ImageSrcSidebar === null"
                          icon="PlusSquareIcon"
                          size="100"
                      />
                    </b-avatar>
                    <input
                        ref="refInputElSidebar"
                        accept=".jpg,.jpeg,.png,.svg"
                        class="d-none"
                        type="file"
                        @change="setCoverSidebar($event)"
                    />
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group class="mb-2" label="Name" label-for="name">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-input
                            id="name"
                            v-model="product.name"
                            :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group class="mb-2" label="SubTitle" label-for="subTitle">
                      <b-form-input
                          id="subTitle"
                          v-model="product.subTitle"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group label="Choose Product Category" label-for="blog-category">
                      <v-select
                          v-if="categories"
                          id="blog-category"
                          v-model="product.productCategoryId"
                          :options="categories"
                          :reduce="(category) => category.id"
                          label="name"
                          placeholder="Choose your desired category"
                      >
                        <template #no-options>There is no category available</template>
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group class="mb-2" label="Price" label-for="priceValue">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-input
                            id="priceValue"
                            v-model="product.priceValue"
                            :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group class="mb-2" label="Discounted price" label-for="discountedPriceValue">
                      <validation-provider #default="{ errors }">
                        <b-form-input
                            id="discountedPriceValue"
                            v-model="product.discountedPriceValue"
                            :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group class="mb-2" label="Min Order" label-for="minOrder">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-input
                            id="minOrder"
                            v-model="product.minOrder"
                            :state="errors.length > 0 ? false : null"
                        ></b-form-input>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="6">
                    <b-form-group label="Choose Product Shipments" label-for="shipments">
                      <v-select
                          v-if="shipments"
                          id="shipments"
                          v-model="product.shipments"
                          :multiple="true"
                          :options="shipments"
                          :reduce="(shipment) => shipment.id"
                          label="name"
                          placeholder="Choose your desired shipments"
                      >
                        <template #no-options>There is no shipments available</template>
                      </v-select>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mb-2" label="Short Description" label-for="shortDescription">
                      <validation-provider #default="{ errors }" rules="required">
                        <b-form-textarea
                            id="shortDescription"
                            v-model="product.shortDescription"
                            :state="errors.length > 0 ? false : null"
                            maxlength="5000"
                        ></b-form-textarea>
                        <span>{{ (product.shortDescription || '').length }}</span>
                        <span> / 5000 Characters</span>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" md="12">
                    <b-form-group class="mb-2" label="Full Description">
                      <ckEditorMain
                          ref="editorContent"
                          :defaultContent="product.fullDescription"
                          @getEditorContent="setEditorContent"
                      ></ckEditorMain>
                    </b-form-group>
                  </b-col>

                  <b-col v-if="product" cols="6" class="my-1">
                    <h1>Product Index Status</h1>
                    <b-form-group label="allow indexing" label-for="name">
                      <b-form-checkbox v-model="product.isIndex" switch />
                    </b-form-group>
                    <b-form-group label="allow following" label-for="name">
                      <b-form-checkbox v-model="product.isFollow" switch />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>

              <b-card>
                <b-row>
                  <b-col cols="12">
                    <b-button
                        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                        class="col-12 col-md-2"
                        variant="primary"
                        @click="updateProduct"
                    >
                      Update product detail
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </validation-observer>

              <b-card>
                <b-row>
                  <h4 class="text-primary col-12 mb-2">Properties</h4>

                  <b-col v-for="(property, idx) in product.properties" :key="idx" cols="12">
                    <ProductCategoryProperty :CPG="CPG" :idx="idx" :product="product" :property="property"/>
                  </b-col>
                  <b-col cols="12">
                    <b-button
                        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                        class="col-12 col-md-2"
                        variant="success"
                        @click="addProperty"
                    >
                      + Add property
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>

              <!-- ================== Trailer ================== -->
              <b-card>
                <b-row>
                  <h4 class="text-primary col-12 mb-2">Trailer</h4>
                  <b-col cols="12" md="3">
                    <video
                        v-if="base64Trailer"
                        :src="base64Trailer"
                        controls
                        crossorigin
                        playsinline
                        style="max-height: 30rem"
                    ></video>
                    <b-button
                        class="mt-2 col-6"
                        variant="warning"
                        @click="$refs.refInputEl2.click()"
                    >
                      Add video
                    </b-button>
                    <!-- input is now a SIBLING of the button, not a child -->
                    <input
                        ref="refInputEl2"
                        accept=".webm,.mp4,.ogg"
                        class="d-none"
                        type="file"
                        @change="setVideo"
                    />
                  </b-col>
                </b-row>
              </b-card>

              <b-card>
                <div class="mb-1 w-100 d-flex align-items-center justify-content-between">
                  <h1>Seo</h1>
                </div>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form @submit.prevent>
                      <b-form-group label="Seo title" label-for="seoTitle">
                        <validation-provider #default="{ errors }" rules="required">
                          <b-form-input
                              id="seoTitle"
                              trim
                              placeholder=""
                              v-model="product.seoTitle"
                              :state="errors.length > 0 ? false : null"
                          />
                        </validation-provider>
                      </b-form-group>
                    </b-form>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form @submit.prevent>
                      <b-form-group label="Seo Url" label-for="seoURL">
                        <validation-provider #default="{ errors }" rules="required">
                          <b-form-input
                              id="seoURL"
                              trim
                              placeholder=""
                              v-on:focus="$event.target.select()"
                              v-model="allCharactersToDash"
                              :state="errors.length > 0 ? false : null"
                          />
                        </validation-provider>
                      </b-form-group>
                    </b-form>
                  </b-col>
                  <b-col cols="12">
                    <b-form @submit.prevent>
                      <b-form-group label="Seo Description" label-for="seoDescription">
                        <validation-provider #default="{ errors }" rules="required">
                          <b-form-textarea
                              id="seoDescription"
                              trim
                              placeholder=""
                              v-model="product.seoDescription"
                              :state="errors.length > 0 ? false : null"
                          />
                        </validation-provider>
                      </b-form-group>
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="12">
                    <!-- serp Desktop -->
                    <div class="serp-preview d-lg-flex p-3 d-none flex-column align-items-start">
                      <div class="serp-title">
                        <h4 style="color: rgb(26, 13, 171) !important">
                          {{ product.seoTitle }}
                        </h4>
                      </div>
                      <div class="serp-url">
                        <h5 class="d-flex align-items-center flex-wrap" style="color: rgb(0, 102, 33) !important">
                          <span>
                            {{ `https://ariaexport.com${langs[product.languageId]}/products/` }}
                          </span>
                          <span style="overflow-wrap: anywhere">{{ allCharactersToDash }}</span>
                        </h5>
                      </div>
                      <div class="serp-description">
                        <h6 style="overflow-wrap: anywhere">{{ product.seoDescription }}</h6>
                      </div>
                    </div>
                    <!-- serp Mobile -->
                    <div class="serp-preview d-lg-none p-3 d-flex flex-column align-items-start">
                      <div class="serp-title">
                        <h6>{{ product.seoTitle }}</h6>
                      </div>
                      <div class="serp-url d-flex align-items-center flex-wrap">
                        <small>
                          {{ `https://ariaexport.com${langs[product.languageId]}/products/` }}
                        </small>
                        <small>{{ allCharactersToDash }}</small>
                      </div>
                      <div class="serp-description">
                        <small>{{ product.seoDescription }}</small>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-button
                        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                        class="col-12 col-md-2"
                        variant="success"
                        @click="updateProductSeo"
                    >
                      Update product Seo
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>

              <Tag
                  class="mb-2"
                  v-if="product"
                  :object-id="$route.params.id"
                  entity-type="4"
                  :languageId="product.languageId"
              />
              <Meta v-if="product && product.meta" :data="product.meta" />

              <b-card>
                <h1>Scripts</h1>
                <b-form-textarea
                    placeholder="Scripts"
                    id="script"
                    v-model="product.script"
                    class="mt-2"
                ></b-form-textarea>
              </b-card>
          </b-media>
        </b-row>
      </b-col>
    </b-row>

    <library-image-picker @insertImage="insertImage" @insertVideo="insertVideo"></library-image-picker>
  </b-overlay>
</template>

<script>
import {
  BAlert,
  BAvatar,
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BImg,
  BLink,
  BMedia,
  BModal,
  BOverlay,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
} from "bootstrap-vue";
import vSelect from "vue-select";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Helper from "@/libs/Helper";
import {required} from "@validations";
import {CategoryPropertyGroupGetBy, ProductCategoriesGetSubCategories,} from "@/libs/Api/ProductCategory";
import LanguagePicker from "@/views/components/utils/LanguagePicker.vue";
import AddEditDeleteButton from "@/views/components/utils/AddEditDeleteButton.vue";
import {GetAllLangs} from "@/libs/Api/Language";
import {ShipmentGetAll} from "@/libs/Api/Shipment";
import ckEditorMain from "@/views/components/ckEditorMain.vue";
import ProductCategoryProperty from "@/views/apps/product/ProductCategoryProperty.vue";
import {ProductGetBy, ProductUpdate, ProductUpdateSeoURL,} from "@/libs/Api/Product";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {quillEditor} from "vue-quill-editor";
import QuillToolbar from "@/views/components/utils/QuillToolbar.vue";
import LibraryImagePicker from "@/views/components/utils/LibraryImagePicker.vue";
import Tag from "@/views/components/Tag.vue";
import Meta from "@/views/components/Meta.vue";

export default {
  title: "Edit product",
  data() {
    return {
      required,
      productId: this.$route.params.id,
      languageList: [],
      overlay: false,
      categories: [],
      shipments: [],
      CPG: [],
      langs: {2: "/fa", 1: "", 3: "/ar", 4: "/ru", 6: "/tr"},
      product: null,
      base64ImageSrc: null,
      base64ImageSrcSidebar: null,
      modalCoverPic: null,
      base64Trailer: null,
      selectedVideoFile: null,
      editorOption: {
        modules: {
          toolbar: {
            align: ["", "right", "center", "justify"],
            container: "#toolbar",
            handlers: {image: this.imageMethod, video: this.imageMethod},
          },
        },
        theme: "snow",
      },
    };
  },
  async created() {
    try {
      await this.getProduct();
    } catch (e) {
      console.log(e);
    } finally {
      await this.getSubCategories();
      await this.getShipments();
    }
  },
  watch: {
    "product.languageId": function () {
      this.getSubCategories();
      this.getShipments();
    },
    "product.productCategoryId": function () {
      this.getCategoryPropertyGroup();
    },
  },
  computed: {
    allCharactersToDash: {
      get: function () {
        return this.product.seoUrl;
      },
      set: function (newValue) {
        if (newValue) {
          this.product.seoUrl = newValue;
          this.product.seoUrl = this.product.seoUrl.replace(
              /[+*!@#$%^&*()_;:~`»«,×='"|<>/?{}\/\.]/g,
              ""
          );
          this.product.seoUrl = this.product.seoUrl.replaceAll(" ", "-");
        } else if (!newValue || this.product.seoUrl === "") {
          this.product.seoUrl = null;
        }
      },
    },
  },
  methods: {
    async getProduct() {
      let _this = this;
      _this.overlay = true;

      let productGetBy = new ProductGetBy(_this);
      productGetBy.setParams({id: _this.productId});
      await productGetBy.fetch(
          function (content) {
            _this.overlay = false;
            _this.product = content.data;

            // ---- null-safe URL building (was producing "baseUrlnull") ----
            _this.base64ImageSrc = _this.product.imageURl
                ? Helper.baseUrl + _this.product.imageURl
                : null;
            _this.base64ImageSrcSidebar = _this.product.sideImage
                ? Helper.baseUrl + _this.product.sideImage
                : null;
            _this.base64Trailer = _this.product.videoURl
                ? Helper.baseUrl + _this.product.videoURl
                : null;

            if (!_this.product.meta) {
              _this.product.meta = {metas: [], links: []};
            } else {
              _this.product.meta = JSON.parse(_this.product.meta);
            }
          },
          function (error) {
            _this.overlay = false;
            console.log(error);
          }
      );
    },

    // ============================================================
    //  ⭐ REWRITTEN: files extracted out of the JSON payload
    // ============================================================
    async updateProduct() {
      const _this = this;

      Helper.validateForm(_this, "refFormObserver", async () => {
        try {
          _this.overlay = true;

          // 1) Which values are real File objects (new upload) vs URL strings (existing)?
          const newImageFile =
              _this.product.imageURl instanceof File ? _this.product.imageURl : null;
          const newSidebarFile =
              _this.product.sideImage instanceof File ? _this.product.sideImage : null;
          const newVideoFile = _this.selectedVideoFile;

          // 2) Build a JSON-safe copy — no File objects, meta already stringified.
          //    If a new file is being uploaded, blank out the URL field so the
          //    backend does not fight the File part.
          const productForPayload = {
            ..._this.product,
            imageURl: newImageFile ? "" : _this.product.imageURl || "",
            sideImage: newSidebarFile ? "" : _this.product.sideImage || "",
            videoURl: newVideoFile ? "" : _this.product.videoURl || "",
            meta:
                typeof _this.product.meta === "string"
                    ? _this.product.meta
                    : JSON.stringify(_this.product.meta || {metas: [], links: []}),
          };
          // File fields must contain binaries only, never an existing video URL.
          delete productForPayload.VideoFile;
          delete productForPayload.videoFile;
          // 3) Let Helper build the base FormData from JSON-safe data only.
          const formData = Helper.generateAnyFormData(productForPayload);

          // 4) Attach the real binaries with the field names the backend expects.
          if (newImageFile) {
            formData.append("ImageFile", newImageFile, newImageFile.name);
          }
          if (newSidebarFile) {
            formData.append("SideBarImageFile", newSidebarFile, newSidebarFile.name);
          }
          if (newVideoFile) {
            formData.append("VideoFile", newVideoFile, newVideoFile.name);
          }

          // 5) Send
          const productUpdate = new ProductUpdate(_this);
          productUpdate.setParams(formData);

          await productUpdate.sendFormData(
              () => {
                _this.overlay = false;
                _this.$toast({
                  component: ToastificationContent,
                  position: "bottom-center",
                  props: {
                    title: `Operation successful`,
                    icon: "CheckIcon",
                    variant: "success",
                  },
                });
                window.location.reload();
              },
              (error) => {
                _this.overlay = false;
                console.error("Update product failed:", error);
              }
          );
        } catch (err) {
          _this.overlay = false;
          console.error("updateProduct error:", err);
        }
      });
    },

    async updateProductSeo() {
      let _this = this;
      _this.overlay = true;

      let data = {
        id: _this.productId,
        seoTitle: _this.product.seoTitle,
        seoDescription: _this.product.seoDescription,
        seoUrl: _this.product.seoUrl,
      };

      let productUpdateSeoURL = new ProductUpdateSeoURL(_this);
      productUpdateSeoURL.setParams(data);
      await productUpdateSeoURL.fetch(
          function () {
            _this.overlay = false;
            _this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {title: `Operation successful`, icon: "CheckIcon", variant: "success"},
            });
            window.location.reload();
          },
          function (error) {
            _this.overlay = false;
            console.log(error);
          }
      );
    },

    async getCategoryPropertyGroup() {
      let _this = this;
      _this.overlay = true;

      let categoryPropertyGroupGetBy = new CategoryPropertyGroupGetBy(_this);
      categoryPropertyGroupGetBy.setParams({
        ProductCategoryId: _this.product.productCategoryId,
        languageId: _this.product.languageId,
      });
      await categoryPropertyGroupGetBy.fetch(
          function (content) {
            _this.overlay = false;
            _this.CPG = content.data.data;
          },
          function (error) {
            _this.overlay = false;
            console.log(error);
          }
      );
    },

    async getSubCategories() {
      let _this = this;
      _this.overlay = true;

      let productCategoriesGetSubCategories = new ProductCategoriesGetSubCategories(_this);
      productCategoriesGetSubCategories.setParams({languageId: _this.product.languageId});
      await productCategoriesGetSubCategories.fetch(
          function (content) {
            _this.overlay = false;
            _this.categories = content.data.data;
          },
          function (error) {
            _this.overlay = false;
            console.log(error);
          }
      );
    },

    async getShipments() {
      let _this = this;
      _this.overlay = true;

      let shipmentGetAll = new ShipmentGetAll(_this);
      shipmentGetAll.setParams({languageId: _this.product.languageId});
      await shipmentGetAll.fetch(
          function (content) {
            _this.overlay = false;
            _this.shipments = content.data.data;
          },
          function (error) {
            _this.overlay = false;
            console.log(error);
          }
      );
    },

    addProperty() {
      this.product.properties.push({
        categoryPropertyId: 0,
        categoryPropertyGroupId: 0,
        value: "",
        priority: "",
        showInContent: false,
      });
    },

    generateObjectForAddEditRemoveButton(data) {
      return {
        id: data.id,
        languageId: data.languageId,
        otherLanguages: data.otherLanguages || [],
        mainId: data.mainId,
      };
    },

    async getAllLanguages() {
      try {
        let requestParams = {count: 100, pageNumber: 1};
        if (this.searchCommand) requestParams["searchCommand"] = this.searchCommand;
        this.isLoading = true;
        let _this = this;
        let getAllLangs = new GetAllLangs(_this);
        getAllLangs.setRequestParam(requestParams);
        await getAllLangs.fetch((response) => {
          if (response.isSuccess) _this.languageList = response.data.languages;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    setEditorContent(content) {
      this.product.fullDescription = content;
    },
    clickOnInput(id) {
      document.getElementById(id).click();
    },
    setLanguageId(language) {
      this.product.languageId = language.languageId;
    },

    // ---- guards in case user cancels the file dialog ----
    setCover(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.product.imageURl = file;
      this.base64ImageSrc = URL.createObjectURL(file);
    },
    setCoverSidebar(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.product.sideImage = file;
      this.base64ImageSrcSidebar = URL.createObjectURL(file);
    },
    setVideo(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.selectedVideoFile = file;
      this.base64Trailer = URL.createObjectURL(file);
    },

    imageMethod() {
      this.$bvModal.show("library-image-picker-modal");
    },
    insertImage(imageUrl) {
      const q = this.$refs.quillEditor && this.$refs.quillEditor.quill;
      if (!q) return;
      q.insertEmbed(q.getSelection()?.index || 1, "image", imageUrl);
    },
    insertVideo(videoUrl) {
      const q = this.$refs.quillEditor && this.$refs.quillEditor.quill;
      if (!q) return;
      q.insertEmbed(q.getSelection()?.index || 1, "video", videoUrl);
    },
  },
  components: {
    BFormCheckbox, Meta, Tag, QuillToolbar, ckEditorMain,
    AddEditDeleteButton, LanguagePicker, BModal, BCard, BCardBody,
    BRow, BCol, BImg, BCardText, BLink, BButton, BDropdown,
    BDropdownItem, BAlert, BTab, BTabs, BForm, BFormGroup,
    BFormInput, BFormTextarea, BMedia, BAvatar, BOverlay,
    vSelect, BTable, BPagination, ValidationObserver,
    ValidationProvider, ProductCategoryProperty, quillEditor,
    LibraryImagePicker,
  },
};
</script>

<style>
.modal-header > .close {
  display: none !important;
}
</style>
